export const POSTHOG_SIGNUP_DISTINCT_ID_COOKIE = 'plotsalot_signup_distinct_id';
export const POSTHOG_SIGNUP_DISTINCT_ID_COOKIE_MAX_AGE_SECONDS = 30 * 60;

export function isValidPostHogDistinctId(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0 && value.length <= 512;
}

export function isAnonymousSignupDistinctId(value: unknown): value is string {
  // The web SDK generates UUIDs; database account IDs are CUIDs, not anonymous IDs.
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}
